import React, { useContext } from 'react'
import { AppContext } from '../constants'

const FilterRadioBtn = (props) => {
  const { name, value, label, isChecked = false } = props
  const { formId, handleRadioChange } = useContext(AppContext)

  return (
    <label className={'currency-chart__period-filters-btn ' + (isChecked ? 'currency-chart__period-filters-btn--isChecked' : '')}>
      <input form={formId} type='radio' name={name} value={value} onChange={handleRadioChange} checked={isChecked} />
      {label}
    </label>
  )
}

export default FilterRadioBtn
